'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductBadge({
  background,
  color,
  text,
}: {
  background: string;
  color: string;
  text: string;
}) {
  return (
    <div
      className={cn(
        'ea-product-badge',
        'flex h-5 items-center justify-center rounded-[2px] px-3 text-[11px] font-medium uppercase tracking-tight sm:text-[12px]',
      )}
      style={{ backgroundColor: background, color: color }}
    >
      {text}
    </div>
  );
}
